module.exports = __webpack_public_path__ + "ath_game_web/img/4.1.32700e0e.png";